<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="4" fill="#A44EFF" />
    <path
      d="M13.0059 14H11.9629V6.50586H7.43945V14H6.37891V5.54492H13.0059V14Z"
      fill="white"
    />
  </svg>
</template>
